<template>
  <div class="skeketon">
    <div class="skeketon-header">
      <div></div>
    </div>
    <div class="skeketon-bar">
      <div></div>
    </div>
    <div class="skeketon-center">
      <a v-for="i in 10" :key="i">
        <span></span>
      </a>
    </div>
    <div class="skeketon-new">
      <p ></p>
    </div>
    <div class="skeketon-bottom" v-for="i in 6" :key="i">
      <p class="box1"></p>
      <p class="box2"></p>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  }
}
</script>
<style lang='scss' scoped>
.skeketon {
  @include skeletonBlink();
  height: calc(100vh - 50px);
  overflow: hidden;
  position: relative;
  &-header{
    @include wh(100%,45px);
    background: var(--APP_skeleton_background_color);
    @include center();
    div{
      @include wh(80%,28px);
      background: var(--APP_skeleton_color);
      border-radius: 4px;
    }
  }
  &-bar {
    @include wh(100%,150px);
    @include center();
    div{
      @include wh(355px,121px);
      background: var(--APP_skeleton_background_color);
      border-radius: 10px;
    }
  }
  &-center {
    border-bottom: 1px solid #e5e5e5;
    background: #fff;
    border-radius: 4px 4px 0 0;
    margin-bottom: 10px;
    overflow: hidden;
    padding-top:10px;
    // margin: 5px 10px;
    margin: 0px 10px 5px 10px;
    text-align: center;
    a {
      @include wh(20%,70px);
      float: left;
      background: var(--APP_skeleton_background_color);
      text-align: center;
    }
    span {
      @include wh(50px,50px);
      display: inline-block;
      background: var(--APP_skeleton_color);
      border-radius: 4px;
    }
    p {
      @include wh(80%,18px);
      background: var(--APP_skeleton_color);
      margin-left: 10%;
    }
  }
  &-new {
    border-radius: 0 0 4px 4px;
    height: 0.4rem;
    padding: 5px 20px;
    box-sizing: border-box;
    margin: 0 0.1rem;
    margin-top: 0.01rem;
    margin-bottom: 0.05rem;
    background: var(--APP_skeleton_background_color);
    display: flex;
    p{
      background: var(--APP_skeleton_color);
      margin-right:10px;
      flex: 1;
      border-radius: 4px;
    }
  }
  &-bottom{
    height: 70px;
    margin: 0 0.1rem 0.05rem 0.1rem;
    background: var(--APP_skeleton_background_color);
    display: flex;
    p{
      flex:1;
      background: var(--APP_skeleton_color);
      margin:10px;
      border-radius: 4px;
    }
  }
}
</style>
